import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBeganeGrond = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      d="M35 27H5v6h30z"
    />
    <path
      fill="#00C5F2"
      d="M26 27a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBeganeGrond);

export default ForwardRef;
